import FlightTop from './FlightTop';
import flightTopSchema from './schema';

export { flightTopSchema };
export default FlightTop;
